import React, { FC } from 'react'
import { FavoriteIcon } from '../../images/favorite_icon'

type FavoriteButtonProps = {
  isFavorited: boolean
  isOwn: boolean
  onClick: () => void
}

const FavoriteButton: FC<FavoriteButtonProps> = (props) => {
  if (props.isOwn) {
    return <></>
  }
  return (
    <button
      className="flex items-center justify-center cursor-pointer"
      onClick={(e) => {
        e.stopPropagation()
        props.onClick()
      }}
      type="button"
    >
      <FavoriteIcon isActive={props.isFavorited} />
    </button>
  )
}

export default FavoriteButton
